import { addListener } from "@grindex-common/helpers/domManipulation";
import { ImageRotateSliderDom } from "./imageRotateSlider.dom";

const FPS_DEFAULT = 60;
const MONITOR_INTERVAL = 10;
const DRAG_SPEED_MULTIPLIER = 10;

function init($views) {
	const $module = $views[0];
	const dom = new ImageRotateSliderDom($module);
	const frames = [];
	const folderId = $module.dataset.folderid;

	let ready = false;
	let dragging = false;
	let pointerStartPosX = 0;
	let pointerEndPosX = 0;
	let pointerDistance = 0;
	let monitorStartTime = 0;
	let totalFrames = 0;
	let currentFrame = 0;
	let endFrame = 0;
	let ticker = 0;
	let hideArrowsTimer = 0;
	let maxImageWidth = 0;

	loadImages();

	bindEvents();

	function bindEvents() {
		addListener($module, "mousedown", rotateStart.bind(this));
		addListener($module, "touchstart", rotateStart.bind(this));
		addListener($module, "touchmove", rotateMove.bind(this));
		addListener($module, "touchend", rotateStop.bind(this));

		addListener(document, "mousemove", rotateMove.bind(this));
		addListener(document, "mouseup", rotateStop.bind(this));

		addListener(window, "resize", setContainerMaxWidth.bind(this));
	}

	function loadImages() {
		const url = `/imagerotateslider/getrotatorimages?folder=${folderId}`;

		fetch(url)
			.then((response) => response.json())
			.then((result) => {
				if (result.length === 0) {
					dom.hideContainer();
				} else {
					totalFrames = result.length;
					processImageArray(result, 0, function () {
						totalFrames = frames.length;

						dom.fadeInFirstImage();

						dom.hideLoaderPercentage();

						dom.fadeInArrows();

						showThreeSixty();
					});
				}
			})
			.catch(function (error) {
				dom.hideContainer();
				console.warn(`Failed to load rotator: ${error}`);
			});
	}

	function getImage(url, callback) {
		var image = new Image();

		image.onload = function () {
			if (image.width !== 0) {
				dom.getImageContainerElement().appendChild(image);

				frames.push(image);
			}

			callback();
		};

		image.onerror = function () {
			callback();
		};

		image.src = url;
	}

	function processImageArray(array, index, callback) {
		getImage(array[index], () => {
			const currentIndex = index + 1;

			if (currentIndex === array.length) {
				callback();
				return;
			}

			processImageArray(array, currentIndex, callback);

			dom.getLoaderPercentage().innerText = Math.floor((currentIndex / totalFrames) * 100) + "%";
		});
	}

	function showThreeSixty() {
		ready = true;
		setContainerMaxWidth();
		refresh();
	}

	function render() {
		if (currentFrame !== endFrame) {
			/*
				Calculates the 10% of the distance between the "currentFrame" and the "endFrame".
				By adding only 10% we get a nice smooth and eased animation.
				If the distance is a positive number, we have to ceil the value, if its a negative
				number, we have to floor it to make sure that the "currentFrame" value surely
				reaches the "endFrame" value and the rendering doesn't end up in an infinite loop.
			*/
			const frameEasing = endFrame < currentFrame ? Math.floor((endFrame - currentFrame) * 0.1) : Math.ceil((endFrame - currentFrame) * 0.1);

			hidePreviousFrame();

			currentFrame += frameEasing;

			showCurrentFrame();
		} else {
			clearInterval(ticker);
			ticker = 0;
		}
	}

	function refresh() {
		if (ticker === 0) {
			ticker = setInterval(render.bind(this), Math.round(1000 / FPS_DEFAULT));
		}
	}

	function hidePreviousFrame() {
		const frameIndex = getNormalizedCurrentFrame();
		dom.hideImage(frameIndex);
	}

	function showCurrentFrame() {
		const frameIndex = getNormalizedCurrentFrame();
		dom.showImage(frameIndex);
	}

	function getNormalizedCurrentFrame() {
		const normalizedFrame = -Math.ceil(currentFrame % totalFrames);

		// Returns the "currentFrame" value translated to a value inside the range of 0 and "totalFrames"
		if (normalizedFrame < 0) {
			return normalizedFrame + (totalFrames - 1);
		}

		return normalizedFrame;
	}

	function getPointerEvent(event) {
		// Returns a simple event regarding the original event is a mouse event or a touch event.
		return event.targetTouches ? event.targetTouches[0] : event;
	}

	function rotateStart(event) {
		if (ready) {
			event.preventDefault();
			pointerStartPosX = getPointerEvent(event).pageX;
			dragging = true;
			hideArrows();
		}
	}

	function rotateMove(event) {
		if (ready) {
			event.preventDefault();
			trackPointer(event);
		}
	}

	function rotateStop(event) {
		if (ready) {
			event.preventDefault();
			dragging = false;
			showArrows();
		}
	}

	function trackPointer(event) {
		const userDragging = ready && dragging ? true : false;
		if (userDragging) {
			pointerEndPosX = getPointerEvent(event).pageX;

			if (timeToTrack()) {
				pointerDistance = pointerEndPosX - pointerStartPosX;

				// Calculates the endFrame using the distance between the pointer X starting
				// and ending positions and the "speedMultiplier" values
				endFrame = calculateEndFrame(pointerDistance);

				refresh();

				monitorStartTime = new Date().getTime();

				pointerStartPosX = getPointerEvent(event).pageX;
			}
		}
	}

	function calculateEndFrame(distance) {
		return currentFrame + Math.ceil((totalFrames - 1) * DRAG_SPEED_MULTIPLIER * (distance / dom.getSliderWidth()));
	}

	function timeToTrack() {
		return monitorStartTime < new Date().getTime() - MONITOR_INTERVAL;
	}

	function setContainerMaxWidth() {
		const containerWidth = dom.getModuleWidth();

		if (ready) {
			setImagesMaxWidth();

			maxImageWidth = Math.min(maxImageWidth, containerWidth);

			if (maxImageWidth !== 0) {
				dom.setSliderWidth(maxImageWidth);
				dom.setWrapperWidth(maxImageWidth);
				dom.setModuleHeight(dom.getCurrentImageHeight());
			} else {
				var timeout = setTimeout(() => {
					setContainerMaxWidth();
					clearTimeout(timeout);
				}, 1000);
			}
		}
	}

	function setImagesMaxWidth() {
		maxImageWidth = Math.max.apply(
			Math,
			[...dom.getImages()].map(($image) => {
				return $image.naturalWidth;
			}),
		);
	}

	function hideArrows() {
		clearTimeout(hideArrowsTimer);
		dom.hideArrows();
	}

	function showArrows() {
		clearTimeout(hideArrowsTimer);
		hideArrowsTimer = dom.fadeInArrows();
	}
}

export default {
	view: "imageRotateSlider",
	init,
};
